import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import DetailsCard from './DetailsCard';
import InlineNomineeForm from './InlineNomineeForm';

const StaffCard = ({ 
    staffData, 
    onDelete,
    onSaveNominee,
    relations = []
}) => {
    const { beneficiary, nominee } = staffData;
    const [showNomineeForm, setShowNomineeForm] = useState(false);

    const hasValidBeneficiary = beneficiary && Object.keys(beneficiary).length > 0 && beneficiary.full_name;
    const hasValidNominee = nominee && Object.keys(nominee).length > 0 && nominee.full_name;

    const handleSaveNominee = (nomineeData) => {
        if (onSaveNominee) {
            onSaveNominee(nomineeData, beneficiary.beneficiary_id);
        }
        setShowNomineeForm(false);
    };

    // Simplified delete handlers
    const handleDeleteBeneficiary = () => {
        if (onDelete) {
            onDelete('beneficiary');
        }
    };

    const handleDeleteNominee = () => {
        if (onDelete) {
            onDelete('nominee');
        }
    };

    const beneficiaryDetails = hasValidBeneficiary ? [
        { label: 'Name', value: beneficiary.full_name },
        { label: 'D.O.B', value: beneficiary.dob },
        { label: 'Age', value: `${beneficiary.age}y`},
        { label: 'Gender', value: beneficiary.gender },
        { label: 'Mobile No.', value: beneficiary.phone_number },
    ] : [];

    const nomineeDetails = hasValidNominee ? [
        { label: 'Name', value: nominee.full_name },
        { label: 'D.O.B', value: nominee.dob },
        { label: 'Age', value: `${nominee.age}y`},
        { label: 'Gender', value: nominee.gender },
        { label: 'Relation', value: nominee.relation },
        { label: 'Mobile No.', value: nominee.phone_number },
    ] : [];

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                {hasValidBeneficiary && (
                    <DetailsCard
                        title="Beneficiary Details"
                        isDeletable={beneficiary.is_deletable}
                        onDelete={handleDeleteBeneficiary}
                        details={beneficiaryDetails}
                    />
                )}
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'flex'} }}></Grid>
            <Grid item xs={12} md={6}>
                {hasValidNominee ? (
                    <DetailsCard
                        title="Nominee Details"
                        isDeletable={nominee.is_deletable}
                        onDelete={handleDeleteNominee}
                        details={nomineeDetails}
                    />
                ) : hasValidBeneficiary && !showNomineeForm ? (
                    <CustomButton
                        variant="filled"
                        color="primary"
                        onClick={() => setShowNomineeForm(true)}
                        label="Add Nominee"
                        fullWidth
                    />
                ) : null }
            </Grid>
            {showNomineeForm && (
                <>
                <Grid item xs={12} md={6} sx={{ display: {xs: 'none', md: 'flex'} }}></Grid>
                <Grid item xs={12} md={6}>
                    <InlineNomineeForm
                        staffData={staffData}
                        onSave={handleSaveNominee}
                        relations={relations}
                    />
                </Grid>
                </>
            )}
        </Grid>
    );
};

export default StaffCard;